import { render, staticRenderFns } from "./pastServeList.vue?vue&type=template&id=4a70775b&scoped=true&"
import script from "./pastServeList.vue?vue&type=script&lang=js&"
export * from "./pastServeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70775b",
  null
  
)

export default component.exports